<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position:relative;">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <span class="main-title">FOOD SUMMARY | &nbsp;</span>
          <span class="submain-title">Store payment</span></v-flex
        >
        <v-flex xs12 sm6 style="display:flex;justify-content:flex-end">
          <download-excel
            :data="export_form_store_payment"
            :fields="{
              No: 'No',
              'Store name': 'store_name',
              Package: 'package',
              'Order type': 'order_type',
              'Bank No.': 'bank_no',
              'Bank Name': 'bank_name',
              'Bank Type': 'bank_type',
              Revenue: 'circulation',
              'Commission%': 'commission',
              'Commission paid': 'deduction',
              Paid: 'amount_paid',
              'Total paid': 'total_paid',
            }"
            :name="
              'StorePaymentReport-' +
                (search_config.search_store_id == 0
                  ? 'All_store'
                  : store_payment_list.length > 0
                  ? store_payment_list[0].store_name
                  : '') +
                '_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.xls'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.xls </v-btn>
          </download-excel>
          <download-excel
            type="csv"
            :data="export_form_store_payment"
            :fields="{
              No: 'No',
              'Store name': 'store_name',
              Package: 'package',
              'Bank No.': 'bank_no',
              'Bank Name': 'bank_name',
              'Bank Type': 'bank_type',
              Revenue: 'circulation',
              'Commission%': 'commission',
              'Commission paid': 'deduction',
              Paid: 'amount_paid',
              'Total paid': 'total_paid',
            }"
            :name="
              'StorePaymentReport-' +
                (search_config.search_store_id == 0
                  ? 'All_store'
                  : store_payment_list.length > 0
                  ? store_payment_list[0].store_name
                  : '') +
                '_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.csv'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.csv </v-btn>
          </download-excel>
        </v-flex>
      </v-layout>
    </div>
    <searchFood :action_method="'fetchStorePaymentReport'" />
    <storePayment />
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchFood from "@/components/back-office/Report/SearchBar/SearchFood";
import storePayment from "@/components/back-office/Report/StorePaymentList";
export default {
  data() {
    return {
      items: [
        "Sort by revenue Max to Min",
        "Sort by revenue Min to Max",
        "Sort by store name",
      ],
    };
  },
  components: {
    searchFood,
    storePayment,
  },
  destroyed() {
    if (this.$route.name != "storePaymentOrder") {
      this.$store.commit("fetchStorePaymentReport/resetState");
    }
  },
  computed: {
    ...mapState({
      search_config: (state) => state.fetchStorePaymentReport.clone_config_path,
      export_form_store_payment: (state) =>
        state.fetchStorePaymentReport.export_form_store_payment,
      store_payment_list: (state) =>
        state.fetchStorePaymentReport.store_payment_list,
    }),
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Store payment",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/store_payment",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
